// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"zr-z","breadcrumbForward":"Ar-z","breadcrumbBack":"Br-z","selected":"Cr-z"};